import { Link } from "react-router-dom";
import type { MangaSeries } from "@/mocks/manga";

function statusBadge(m: MangaSeries) {
  if (m.isOnHiatus) {
    return { text: "断更", cls: "bg-background-300 text-foreground-700" };
  }
  if (m.isBackfill) {
    return { text: "补更", cls: "bg-accent-500 text-background-50" };
  }
  if (m.isNew) {
    return { text: "新更", cls: "bg-primary-500 text-background-50" };
  }
  if (m.isToday) {
    return { text: "今天更新", cls: "bg-primary-500 text-background-50" };
  }
  return { text: "更新中", cls: "bg-secondary-500 text-background-50" };
}

export default function MangaCard({ manga }: { manga: MangaSeries }) {
  const badge = statusBadge(manga);
  return (
    <Link
      to={`/series/${manga.id}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={manga.cover}
          alt={`${manga.title}封面`}
          title={`${manga.title} ${manga.lastChapter}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className={`absolute left-2 top-2 rounded-full px-2.5 py-1 text-xs font-medium ${badge.cls}`}>
          {badge.text}
        </span>
        <span className="absolute bottom-2 right-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          {manga.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-900 group-hover:text-primary-600">
          {manga.title}
        </h3>
        <p className="truncate text-xs text-foreground-500">{manga.author}</p>
        <p className="truncate text-xs text-primary-600">{manga.lastChapter}</p>
        <div className="mt-2 flex items-center gap-2">
          <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
            <div
              className="h-full rounded-full bg-accent-500"
              style={{ width: `${manga.progress}%` }}
            ></div>
          </div>
          <span className="text-xs text-foreground-500">{manga.progress}%</span>
        </div>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {manga.readers}
          </span>
          <span className="flex items-center gap-1 text-accent-700">
            <i className="ri-star-fill"></i>
            {manga.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}